import { css } from '@emotion/css'
import { imgV2 as img } from '@styles/utils';
import colors from '@styles/colors';
import { smallMobile, mobileOnly, tabletLandscapeUp, tabletPortraitUp, desktopUp, max_900 } from '@v2/styles/breakpoints';

export default {
    overlay: css([{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        marginTop: '0px !important',
        padding: '0px !important',
        [mobileOnly]: {
            overflow: 'auto',
        },
        [tabletPortraitUp]: {
            overflow: 'auto',

        },
        [tabletLandscapeUp]: {
            overflow: 'auto',
        },

        '.prev': {
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: `url(${img('pdp2/previous-mobile.svg')})`,
            backgroundSize: '40px 80px',
            width: 40,
            height: 80,
            position: 'absolute',
            bottom: '45%',
            left: 0,
            zIndex: 1,

            [tabletPortraitUp]: {
                backgroundSize: 'cover',
                width: 70,
                height: 140,
            },

            [tabletLandscapeUp]: {
                backgroundImage: `url(${img('pdp2/previous.svg')})`,
                width: 65,
                height: 65,
                left: 10,
            }
        },

        '.next': {
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: `url(${img('pdp2/next-mobile.svg')})`,
            backgroundSize: '40px 80px',
            width: 40,
            height: 80,
            position: 'absolute',
            bottom: '45%',
            right: 0,
            zIndex: 1,

            [tabletPortraitUp]: {
                backgroundSize: 'cover',
                width: 70,
                height: 140,
            },

            [tabletLandscapeUp]: {
                backgroundImage: `url(${img('pdp2/next.svg')})`,
                width: 65,
                height: 65,
                right: 30,
            },
        },

        'h3': {
            color: colors.RED,
            fontWeight: 800,
            fontSize: 26,
            lineHeight: '26px',
            textTransform: 'uppercase',
            marginBottom: 10,
            [mobileOnly]: {
                fontSize: 14,
                lineHeight: '24px',
                letterSpacing: '0.1em',
            },
            [tabletPortraitUp]: {
                fontSize: 24,
                lineHeight: '30px',
                letterSpacing: '0.2em',
            },
            [tabletLandscapeUp]: {
                fontSize: 18,
                lineHeight: '23px',
                letterSpacing: '3px',
            },
        },
        'h2': {
            color: colors.NAVY,
            fontWeight: 800,
            fontSize: 50,
            lineHeight: '60px',
            textTransform: 'lowercase',
            marginBottom: 43,
            [mobileOnly]: {
                fontSize: 26,
                lineHeight: '135%',
                letterSpacing: '0.02em',
                marginBottom: 33,
            },
            [tabletPortraitUp]: {
                fontSize: 50,
                lineHeight: '60px',
            },
            [tabletLandscapeUp]: {
                fontSize: 50,
                lineHeight: '60px',
            },
        },
        'p': {
            fontWeight: 'bold',
            fontSize: 18,
            lineHeight: '30px',
            maxWidth: 680,
            width: '100%,',
            margin: '0 auto',
            marginBottom: 45,
            [mobileOnly]: {
                fontSize: 15,
                lineHeight: '145%',
                letterSpacing: '0.01em',
                marginBottom: 35,
            },
            [tabletPortraitUp]: {
                fontSize: 26,
                lineHeight: '34px',
            },
            [tabletLandscapeUp]: {
                fontSize: 18,
                lineHeight: '30px',

            },
        },

        'button.button.blue.v2': {
            borderRadius: 25,
            padding: '15px 45px',
            color: colors.PINK_LIGHT,
            backgroundColor: colors.NAVY,
            borderColor: colors.NAVY,
            '&:hover': {
                color: colors.PINK_LIGHT,
                backgroundColor: colors.BLUE,
                borderColor: colors.BLUE,
            }
        },

        'button.button.red.v2': {
            borderRadius: 25,
            padding: '15px 45px',
            '&:hover': {
                color: colors.RED,
                backgroundColor: colors.PINK_SHOP_BUTTON,
                borderColor: colors.PINK_SHOP_BUTTON,
            }
        },

        '.product-wrapper': {
            // maxWidth: '1440px',
            width: '100%',
            margin: '0 auto',
            position: 'relative',
            display: 'flex',
            overflowY: 'auto',
            [mobileOnly]: {
                flexDirection: 'column',
                justifyContent: 'flex-start',
            },
            [tabletPortraitUp]: {
                flexDirection: 'column',
                justifyContent: 'flex-start',

            },
            [tabletLandscapeUp]: {
                height: '100%',
                flexDirection: 'row',
                justifyContent: 'center',
                padding: '0 20px',
            },
            [desktopUp]: {
                padding: 0,
            },

            '.left-side': {
                // position: 'relative',
                height: '100%',
                position: 'sticky',
                top: 0,

                [mobileOnly]: {
                    padding: '50px 24px 0px 24px',
                },
                [tabletPortraitUp]: {
                    padding: '50px 50px 0px 50px',
                    maxWidth: '100%',
                },
                [tabletLandscapeUp]: {
                    maxWidth: '560px',
                    width: '100%',
                    padding: '50px 0 50px 0',
                },

                section: {
                    backgroundColor: '#eaedf6',
                    display: 'flex',
                    justifyContent: 'center',
                    height: '100%',
                    maxHeight: 800,
                    position: 'relative',
                    overflow: 'hidden',
                    alignItems: 'flex-end',

                    [mobileOnly]: {
                        borderRadius: 30,
                        alignItems: 'center',
                    },
                    [tabletPortraitUp]: {
                        borderRadius: 50,
                    },
                    [tabletLandscapeUp]: {
                        marginRight: 40,
                    },


                }
            },

            '.right-side': {
                maxWidth: 840,
                width: '100%',

                [mobileOnly]: {
                    padding: '50px 24px 50px 24px',
                },
                [tabletPortraitUp]: {
                    padding: '50px 50px 50px 50px',
                },
                [tabletLandscapeUp]: {
                    padding: '50px 0 50px 0',
                },

                section: {
                    backgroundColor: '#eaedf6',

                    [mobileOnly]: {
                        marginBottom: 23,
                        borderRadius: 30,
                        padding: '50px 24px 58px 24px',
                    },
                    [tabletPortraitUp]: {
                        borderRadius: 50,
                        marginBottom: 50,
                        padding: '73px 50px 80px 50px',
                        "&:last-of-type": {
                            marginBottom: 0,
                        },
                    },
                    [tabletLandscapeUp]: {
                        padding: '75px 80px 80px 80px',
                    },
                    [desktopUp]: {
                        height: 'auto',
                    },
                    '> div': {
                        height: '100%',
                        // display: 'flex',
                        // alignItems: 'center',
                    },
                    '&.explain-section': {
                        padding: 0,
                        position: 'relative',
                    },
                    '&.developmental-section': {
                        height: 'auto',

                        [mobileOnly]: {
                            marginBottom: 80,
                        },
                        [tabletPortraitUp]: {
                            marginBottom: 190,
                        },
                        [tabletLandscapeUp]: {
                            marginBottom: 110,
                        },
                        [desktopUp]: {
                            marginBottom: 180,
                        },
                        '> div': {
                            minHeight: '100%',
                        }
                    },
                    '&.standard-section': {
                        height: 'auto',
                    },
                    '&.safety-usage-section': {
                        height: 'auto',
                    },

                    '&.bundle-shop-others': {
                        padding: 0,
                    }
                }
            }
        }
    }]),

    action: css([{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'flex-end',

        '.tm-text': {
            color: 'rgba(21, 32, 107, 0.5)',
            fontStyle: 'normal',
            textTransform: 'initial',
            fontWeight: 400,
            fontSize: 15,
            lineHeight: 1,
        },

        '.ratings-section': {
            marginBottom: 12, 
            width: '100%', 
            display: 'flex', 
            flexDirection: 'row', 
            alignItems: 'center', 
            justifyContent: 'space-between',
        },

        '.box-ingredients': {
            marginLeft: 12,
            '> span': {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'baseline',
            },
            '.ing-circle': {
                marginRight: 4,
                backgroundColor: colors.TRANSPARENT,
                [mobileOnly]: {
                    width: 32,
                    height: 32,
                },
                [tabletPortraitUp]: {
                    width: '4vw',
                    height: '4vw',
                    maxWidth: 48,
                    maxHeight: 48,
                    minHeight: 48,
                    minWidth: 48,
                },
                [tabletLandscapeUp]: {
                    width: '2.4vw',
                    height: '2.4vw',
                    maxWidth: 48,
                    maxHeight: 48,
                    minWidth: 'unset',
                    minHeight: 'unset'
                },
                [desktopUp]: {
                    width: '4vw',
                    height: '4vw',
                    maxWidth: 48,
                    maxHeight: 48,
                },
                'img': {
                    width: '100%',
                }
            }
        },

        '.products-rating-container': {
            marginRight: 12,
            marginLeft: 12,
        },

        '.action-wrapper': {
            zIndex: 1,
            width: '100%',
            padding: '30px 20px',
            background: colors.WHITE,
            borderRadius: '0 0 50px 50px',

            '.title': {
                fontStyle: 'normal',
                fontWeight: 800,
                fontSize: 32,
                textAlign: 'center',
                letterSpacing: '0.02em',
                lineHeight: '145%',
                color: colors.NAVY
            },
            '.subtitle': {
                fontStyle: 'normal',
                fontWeight: 800,
                fontSize: 14,
                lineHeight: '145%',
                letterSpacing: '0.1em',
                textAlign: 'center',
                color: '#858585',
            },
            '.single-price': {
                fontStyle: 'normal',
                fontWeight: 800,
                fontSize: 32,
                lineHeight: '145%',
                textAlign: 'center',
                letterSpacing: '0.02em',
                color: colors.GREEN_BRIGHT,
                marginTop: 30,
                marginBottom: 30,
            },

            [mobileOnly]: {
                borderRadius: '0 0 30px 30px',

                '.title': {
                    fontSize: 26,
                    lineHeight: '135%',
                },
                '.subtitle': {
                    fontSize: 12,
                },
                '.single-price': {
                    fontSize: 26,
                },
            },
        },
        '.actions': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: 10,
            gap: 20,
        },

        '.product-image-wrapper': {
            display: 'flex',
            width: '100%',
            height: '420px',
            maxHeight: '600px',
            maxWidth: '100%',
            flexDirection: 'column',
            alignContent: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: 35,
            paddingBottom: 35,

            '.product-image': {
                maxHeight: '100%',
                display: 'block',

                '&.bundle, &.barpacks, &.pouches, &.smoothies, &.bars': {
                    maxWidth: '77%',
                },
            },

            'picture': {
                maxHeight: '100%',
                height: 'auto',
                width: '100%',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                justifyContent: 'center',

                'img': {
                    paddingTop: 40,
                    maxHeight: '100%',
                },
            },
            [tabletLandscapeUp]: {
                maxHeight: '100%',
                height: '420px',

                '.product-image': {
                    //display: 'none',
                },

            },
            /* ----------- Non-Retina Screens ----------- */
            '@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1)': {
                height: '350px',
            },

            /* ----------- Retina Screens ----------- */
            '@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)': {
                height: '350px',
            }
        },

        '.prices': {
            textAlign: 'center',
            fontWeight: 800,
            fontSize: 18,
            letterSpacing: '3px',
            textTransform: 'uppercase',
            color: colors.PDPAGE_PRICE_GREY,
            lineHeight: 1,

            [mobileOnly]: {
                fontSize: 14,
            },
        },

        '.subscribe': {
            color: colors.GREEN_BRIGHT,
            fontSize: 15,
            fontWeight: 600,
            textAlign: 'center',
            marginBottom: 20,

            [mobileOnly]: {
                fontSize: 13,
            },
        },

        '.unit-price': {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            maxWidth: 200,
            marginLeft: 'auto',
            marginRight: 'auto',
            justifyContent: 'space-evenly',
            marginTop: 12,

            [mobileOnly]: {
                marginLeft: 'auto',
                marginRight: 'auto',
            },

            '.default': {
                color: colors.BLUE,
                fontSize: 24,
                marginBottom: 10,
                fontWeight: 800,
            },
            '.regular': {
                color: colors.BLUE,
                textDecorationLine: 'line-through',
                fontSize: 24,
                marginBottom: 10,
                fontWeight: 800,
            },
            '.discount': {
                color: colors.GREEN_BRIGHT,
                fontSize: 24,
                fontWeight: 800,
            },
        },

        [mobileOnly]: {
            '.tm-text': {
                fontSize: 12,
                marginBottom: 5,
            },
        },
    }]),
    description: css([{
        position: 'relative',

        '.pdp-header': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 9,
            [mobileOnly]: {
                marginBottom: 0,
            }
        },
        '.pdp-net-weight': {
            fontSize: 16,
            lineHeight: '30px',
            textTransform: 'capitalize',
            marginRight: 20,
            marginBottom: 0,
            [mobileOnly]: {
                display: 'none',
            }
        },

        h2: {
            [tabletPortraitUp]: {
                marginBottom: 17,
            },
            [tabletLandscapeUp]: {
                marginBottom: 30,
            },
        },

        '.pdp-desc': {
            fontSize: 18,
            fontWeight: 'bold',
            lineHeight: '30px',

            [mobileOnly]: {
                marginBottom: 25,
            },
            [tabletPortraitUp]: {
                marginBottom: 50,
            },
            [tabletLandscapeUp]: {
            },
        },


        '.explanation-video': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 10,
            [mobileOnly]: {
                flexDirection: 'column',
            },
            [tabletPortraitUp]: {
                flexDirection: 'column',
            },
            [tabletLandscapeUp]: {
                flexDirection: 'column',
            },
            [desktopUp]: {
                flexDirection: 'row',
            },
            '.video-box': {
                width: '100%',
                backgroundColor: colors.PINK_LIGHT,
                display: 'flex',
                [mobileOnly]: {
                    borderRadius: 30,
                    marginBottom: 28,
                },
                [tabletPortraitUp]: {
                    minHeight: 130,
                    borderRadius: 50,
                    marginBottom: 80,
                },
                [tabletLandscapeUp]: {
                    maxWidth: 480,
                    marginBottom: 20,
                },
                [desktopUp]: {
                    marginBottom: 0,
                }
            },
            '.video-image': {
                'img': {
                    display: 'block',
                    maxWidth: 260,
                    [mobileOnly]: {
                        maxWidth: '100%',
                        height: 'auto',
                    },
                },
                [tabletPortraitUp]: {
                    marginTop: -38,
                },
            },
            '.video-controls': {
                display: 'flex',
                alignItems: 'center',
                marginLeft: -25,
            },
            '.control': {
                cursor: 'pointer',
                [mobileOnly]: {
                    marginRight: 9,
                    'img': {
                        width: 30,
                        height: 30,
                        marginTop: 50,
                    }
                },
                [tabletPortraitUp]: {
                    marginRight: 19,
                    'img': {
                        width: 50,
                        height: 50,
                        marginTop: 30,
                    }
                },
                [tabletLandscapeUp]: {
                    marginRight: 19,
                    'img': {
                        width: 40,
                        height: 40,
                        marginTop: 30,
                    }
                }
            },
            '.heading': {
                'span': {
                    color: colors.RED,
                    fontWeight: 800,
                    letterSpacing: '2px',
                    textTransform: 'uppercase',
                    marginBottom: 4,
                    [mobileOnly]: {
                        fontSize: 10,
                        lineHeight: '10px',
                        maxWidth: 103,
                        width: '100%',
                        display: 'block',
                    },
                    [tabletPortraitUp]: {
                        fontSize: 16,
                        lineHeight: '16px',
                    },
                    [tabletLandscapeUp]: {
                        fontSize: 12,
                        lineHeight: '16px',
                    }
                },
                'h4': {
                    color: colors.NAVY,
                    fontWeight: 800,
                    lineHeight: '1',
                    textTransform: 'lowercase',
                    maxWidth: 250,
                    width: '100%',
                    paddingRight: 10,
                    [mobileOnly]: {
                        fontSize: 14,
                    },
                    [tabletPortraitUp]: {
                        fontSize: 20,
                    },
                    [tabletLandscapeUp]: {
                        fontSize: 22,

                    }
                }
            },
            '.directions-safety': {
                display: 'flex',
                alignItems: 'center',
                [mobileOnly]: {
                    width: '100%',
                },
                [tabletPortraitUp]: {
                    width: '100%',
                },
                [tabletLandscapeUp]: {
                    width: 'auto',
                },
                '.info-icon': {
                    [mobileOnly]: {
                        marginRight: 12,
                        width: 30,
                        height: 30,
                    },
                    [tabletPortraitUp]: {
                        marginRight: 20,
                        width: 50,
                        height: 50,
                    },
                    [tabletLandscapeUp]: {
                        marginRight: 12,
                        width: 30,
                        height: 30,
                    },
                },
                ".heading": {
                    width: '100%',
                    color: colors.NAVY,
                    fontWeight: 'bold',
                    lineHeight: '16px',
                    letterSpacing: '2px',
                    textTransform: 'uppercase',
                    [mobileOnly]: {
                        fontSize: 12,
                    },
                    [tabletPortraitUp]: {
                        fontSize: 26,
                    },
                    [tabletLandscapeUp]: {
                        fontSize: 13,
                        maxWidth: 94,
                    },
                }
            }
        }
    }]),
    fda: css([{
        img: {
            margin: '0 auto',
            maxWidth: '100%',
            height: '100%',
            display: 'block',
        },
        '.arrows': {
            display: 'flex',
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
            flexDirection: 'row',

            span: {
                margin: 10,
            }
        },
        '.dots': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
            fontSize: '6.5rem',
            span: {
                color: colors.BLUE,
            },
            '.active': {
                color: colors.NAVY,
            }
        }
    }]),
    ingredients: css([{
        display: 'flex',
        alignItems: 'center',
        '.ingedients-list-images': {
            display: 'flex',
            textAlign: 'center',
            [mobileOnly]: {
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 5,
            },
            [tabletPortraitUp]: {
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: 5,
            },
            [tabletLandscapeUp]: {
                justifyContent: 'space-between',
                flexWrap: 'nowrap',
            },
            '.ingredient': {
                [mobileOnly]: {
                    maxWidth: 87,
                    padding: 5,
                },
                [tabletPortraitUp]: {
                    maxWidth: 150,
                    padding: 5,
                },
                [tabletLandscapeUp]: {
                    maxWidth: 200,
                },
            },
            'img': {
                width: '100%',
                height: 'auto',
                display: 'block',

            },
            '.ingredient-title': {
                fontWeight: 'bold',
                lineHeight: '1',
                textAlign: 'center',
                textTransform: 'uppercase',
                [mobileOnly]: {
                    fontSize: 12,
                },
                [tabletPortraitUp]: {
                    fontSize: 14,
                },
                [tabletLandscapeUp]: {
                    fontSize: 14,
                },
            }
        }
    }]),
    explains: css([{
        display: 'flex',
        'h2': {
            maxWidth: 327,
            width: '100%',
            [mobileOnly]: {
                maxWidth: 327,
                width: '100%',
            },
        },
        '.explain-wrapper': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            maxWidth: 360,
            width: '100%',
            [mobileOnly]: {
                padding: '50px 24px 50px 24px',
                marginBottom: 120,
            },
            [tabletPortraitUp]: {
                padding: '73px 50px 80px 50px',
            },
            [tabletLandscapeUp]: {
                padding: '80px 40px 80px 80px',
                maxWidth: 435,
            },
            [desktopUp]: {
                width: '100%',
            },
            '.kids': {
                display: 'none',
                maxWidth: 200,
                width: '100%',
                [tabletPortraitUp]: {
                    display: 'block',
                }
            },
            'h2': {
                fontSize: 30,
                lineHeight: '30px',
            },
            '.video-play': {
                [mobileOnly]: {
                    maxWidth: 77,
                },
                maxWidth: 130,
                width: '100%',
                display: 'block',
            },
            '.body': {
                display: 'none',
                [tabletLandscapeUp]: {
                    display: 'block',
                    zIndex: 1,
                }
            },
            'h4': {
                fontWeight: 800,
                fontSize: 32,
                lineHeight: '50px',
                marginBottom: 5,
                textTransform: 'lowercase'

            },
            'p': {
                fontWeight: 800,
                fontSize: 14,
                lineHeight: '18px',
                letterSpacing: 2,
                textTransform: 'uppercase',
                marginBottom: 0,
            },
        },
        '.purzner-photo': {
            display: 'none',
            maxWidth: 487,
            width: '100%',
            marginRight: -45,
            alignSelf: 'flex-end',
            '&.desktop': {
                [desktopUp]: {
                    display: 'block',
                }
            },
            '&.mobile': {
                position: 'absolute',
                bottom: 0,
                right: 15,
                display: 'block',
                marginRight: 0,
                maxWidth: 260,
                alignSelf: 'flex-end',
                [tabletPortraitUp]: {
                    maxWidth: 360,
                },
                [desktopUp]: {
                    display: 'none',
                }
            }
        }
    }]),
    nutrients: css([{
        '.pdp-facts-table': {
            display: 'flex',
            justifyContent: 'center',
            'th': {
                textAlign: 'center',
                fontWeight: 800,
                fontSize: 30,
                lineHeight: '30px',
                textTransform: 'lowercase',
                [mobileOnly]: {
                    fontSize: 24,
                    "&:first-of-type": {
                        display: 'none',
                    }
                },
            },
            'img': {
                marginLeft: 17,
                maxWidth: 60,
                width: '100%',
                alignSelf: 'center',
                [mobileOnly]: {
                    maxWidth: 40,
                    marginLeft: 0,
                },
            },
            '.title': {
                textAlign: 'right',
                fontWeight: 600,
                fontSize: 13,
                lineHeight: '30px',
                textTransform: 'uppercase',
                padding: '0 17px 0 0',
                [mobileOnly]: {
                    display: 'none',
                },
            },
            '.value': {
                padding: '0 35px',
                textAlign: 'center',
                fontWeight: 800,

                lineHeight: '30px',
                textTransform: 'lowercase',
                [mobileOnly]: {
                    fontSize: 22,
                    padding: '0 20px',
                },
                [tabletPortraitUp]: {
                    fontSize: 30,
                },
            },
        },
        '.disclaimer': {
            marginBottom: 0,
            [mobileOnly]: {
                fontSize: 11,
            },
            [tabletPortraitUp]: {
                fontSize: 12,
            },
            [tabletLandscapeUp]: {
                fontSize: 13,
            },
        }
    }]),
    developmental: css([{
        flexDirection: 'column',
        alignItems: 'baseline',
        'h3': {
            alignSelf: 'baseline',
        },
        '.developmental-tabs': {
            [mobileOnly]: {
                marginBottom: -120,
            },
            [tabletPortraitUp]: {
                marginBottom: -150,
            },
            [tabletLandscapeUp]: {
                marginBottom: -180,
            },
            [desktopUp]: {
                marginBottom: -230,
            },
        },
        '.tabs': {
            display: 'flex',
            alignItems: 'baselione',
            justifyContent: 'space-evenly',
            [mobileOnly]: {
                justifyContent: 'space-evenly',
            },

            '.tab': {
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                [mobileOnly]: {
                    padding: '15px 5px 10px 5px',
                    maxWidth: 65,
                },
                [tabletPortraitUp]: {
                    padding: '25px 0 15px 0',
                    maxWidth: 160,
                },
                [tabletLandscapeUp]: {

                },
                [desktopUp]: {

                },
                '&.active': {
                    backgroundColor: colors.PDPAGE_TABS_SECTION_LIGHT_BLUE,
                    [mobileOnly]: {
                        borderTopLeftRadius: 20,
                        borderTopRightRadius: 20,
                    },
                    [tabletPortraitUp]: {
                        borderTopLeftRadius: 35,
                        borderTopRightRadius: 35,
                    },
                    [tabletLandscapeUp]: {
                    },
                    [desktopUp]: {

                    },
                    position: 'relative',
                    '&:after, &:before':{
                        content:`''`,
                        position: 'absolute',
                        [mobileOnly]: {
                            width: 40,
                            height: 40,
                            bottom: -10,
                            border: `10px solid ${colors.PDPAGE_TABS_SECTION_LIGHT_BLUE}`,
                            borderTop: 0,
                        },
                        [tabletPortraitUp]: {
                            width: 80,
                            height: 80,
                            bottom: -20,
                            border: `20px solid ${colors.PDPAGE_TABS_SECTION_LIGHT_BLUE}`,
                            borderTop: 0,
                        },
                    },
                    '&:after': {
                        [mobileOnly]: {
                            left: -30,
                            borderLeft: 0,
                            borderRadius: '0 0 30px 0',
                        },
                        [tabletPortraitUp]: {
                            left: -60,
                            borderLeft: 0,
                            borderRadius: '0 0 50px 0',
                        },
                    },
                    '&:before': {
                        [mobileOnly]: {
                            right:-30,
                            borderRight: 0,
                            borderRadius: '0 0 0 30px',
                        },
                        [tabletPortraitUp]: {
                            right:-60,
                            borderRight: 0,
                            borderRadius: '0 0 0 50px',
                        },
                    },
                    "&:first-child": {
                        '&:after': {
                            [mobileOnly]: {
                                backgroundColor: colors.PDPAGE_TABS_SECTION_LIGHT_BLUE,
                                left: 0,
                                borderRadius: 0,
                                bottom: -27,
                            },
                            [tabletPortraitUp]: {
                                display: 'block',
                                width: 10,
                                left: 0,
                                bottom: -10,
                            },
                            [tabletLandscapeUp]: {
                                width: 20,
                                left: 0,
                                bottom: -20,
                            },
                            [desktopUp]: {
                                width: 60,
                                left: -40,
                            },
                        }
                    },
                    "&:last-child": {
                        '&:before': {
                            [mobileOnly]: {
                                backgroundColor: colors.PDPAGE_TABS_SECTION_LIGHT_BLUE,
                                right: 0,
                                borderRadius: 0,
                                bottom: -27,
                            },
                            [tabletPortraitUp]: {
                                display: 'block',
                                width: 10,
                                right: 0,
                                bottom: -10,
                            },
                            [tabletLandscapeUp]: {
                                width: 20,
                                right: 0,
                                bottom: -20,
                            },
                            [desktopUp]: {
                                width: 60,
                                right: -40,
                            },
                        }
                    },
                },
                'img': {
                    width: 50,
                    height: 50,
                    display: 'block',
                    [mobileOnly]: {
                        margin: '0 10px',
                    },
                    [tabletPortraitUp]: {
                        margin: '0 20px',
                    },
                },
                'span': {
                    marginTop: 10,
                    textTransform: 'uppercase',
                    zIndex: 1,
                    [mobileOnly]: {
                        fontSize: 10,
                    },
                    [tabletPortraitUp]: {
                        fontSize: 16,
                    },
                    [tabletLandscapeUp]: {

                    },
                    [desktopUp]: {

                    },
                }
            },
        },
        '.tab-content': {
            backgroundColor: colors.PDPAGE_TABS_SECTION_LIGHT_BLUE,
            position: 'relative',
            [mobileOnly]: {
                padding: '26px 19px 83px 19px',
                borderRadius: 30,
            },
            [tabletPortraitUp]: {
                padding: '65px 40px 150px 40px',
                borderRadius: 50,
            },
            [tabletLandscapeUp]: {
                padding: '65px 40px 150px 40px',
                marginLeft: -30,
                marginRight: -30,
            },
            [desktopUp]: {
                padding: '65px 40px 250px 40px',
            },
            'h4': {
                fontWeight: 800,
                color: colors.NAVY,
                textTransform: 'lowercase',
                [mobileOnly]: {
                    fontSize: 26,
                    lineHeight: '20px',
                },
                [tabletPortraitUp]: {
                    fontSize: 30,
                    lineHeight: '34px',
                },
            },
            'h5': {
                fontWeight: 600,
                textTransform: 'uppercase',
                color: colors.RED,
                [mobileOnly]: {
                    fontSize: 12,
                    lineHeight: '16px',
                    letterSpacing: '0.2em',
                },
                [tabletPortraitUp]: {
                    fontSize: 16,
                    lineHeight: '20px',
                    letterSpacing: 3,
                },
            },
            'p': {
                fontWeight: 800,
                color: colors.NAVY,
                [mobileOnly]: {
                    fontSize: 15,
                    lineHeight: '20px',
                    marginBottom: 27,
                },
                [tabletPortraitUp]: {
                    fontSize: 20,
                    lineHeight: '30px',
                    marginBottom: 51,
                },
            },

            '.header': {
                display: 'flex',
                justifyContent: 'space-between',

                marginBottom: 10,
                [mobileOnly]: {
                    flexDirection: 'column',
                    alignItems: 'baseline',
                },
                [tabletPortraitUp]: {
                    flexDirection: 'row',
                    alignItems: 'center',
                },
            },
            '.headings': {
                [mobileOnly]: {
                    order: 2,
                    marginBottom: 24,
                },
                [tabletPortraitUp]: {
                    order: 1,
                },
            },
            '.stage': {
                color: colors.NAVY,
                display: 'inline-flex',
                flexDirection: 'column',
                backgroundColor: colors.WHITE,
                justifyContent: 'center',
                borderRadius: 16,
                padding: '7px 10px',
                [mobileOnly]: {
                    order: 1,
                    marginBottom: 24,
                },
                [tabletPortraitUp]: {
                    order: 2,
                    marginBottom: 0,
                },
                'span': {
                    display: 'block',
                    textAlign: 'center',
                    whiteSpace: 'pre',
                    '&.period': {
                        fontWeight: 'bold',
                        fontSize: 42,
                        lineHeight: '1',
                        textTransform: 'uppercase',
                        [mobileOnly]: {
                            fontSize: 26,
                        },
                        [tabletPortraitUp]: {
                            fontSize: 42,
                        },
                    },
                    '&.months': {
                        fontWeight: 400,
                        lineHeight: '20px',
                        textTransform: 'uppercase',
                        [mobileOnly]: {
                            fontSize: 13,
                        },
                        [tabletPortraitUp]: {
                            fontSize: 16,
                        },
                    },
                }
            },
        },
        '.brain': {
            position: 'relative',
            display: 'block',
            [mobileOnly]: {
                margin: '0 auto',
                marginTop: -64,
                width: 'calc(100% - 40px)',
            },
            [tabletPortraitUp]: {
                margin: '0 auto',
                marginTop: -135,
                width: '100%',
            },
            [tabletLandscapeUp]: {
                margin: '0 auto',
                marginTop: -150,
            },
            [desktopUp]: {
                marginTop: -264,
                width: 'calc(100% - 20px)',
            },
        },
        '.video-controls': {
            display: 'flex',
            alignItems: 'center',
            '.control': {
                marginRight: 18,
                'img': {
                    width: 40,
                }
            },
            '.heading': {
                fontWeight: 600,
                fontSize: 14,
                lineHeight: '18px',
                color: colors.NAVY,
                letterSpacing: 3,
                textTransform: 'uppercase',
            }
        }
    }]),
    standard: css([{
        '.cerebelly-labels': {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            marginBottom: 54,
            [mobileOnly]: {
                flexWrap: 'wrap',
                gap: 10,
            },
            '> div': {
                maxWidth: 128,
                width: '100%',
                textAlign: 'center',
                marginRight: 10,

                '> div': {
                    height: 65,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }
            },
            'img': {
                maxWidth: 100,
                width: '100%',
                display: 'block',
                margin: '0 auto',
            },
            '.number': {
                fontWeight: 800,
                lineHeight: '1',
                color: colors.RED,
                display: 'inline-flex',
                alignItems: 'flex-end',
                justifyContent: 'center',
                [mobileOnly]: {
                    width: 60,
                    height: 60,
                    fontSize: 50,
                },
                [tabletPortraitUp]: {
                    width: 100,
                    height: 70,
                    fontSize: 90,
                },
                '.grams': {
                    display: 'inline-block',
                    textTransform: 'uppercase',
                    [mobileOnly]: {
                        fontSize: 20,
                    },
                    [tabletPortraitUp]: {
                        fontSize: 30,
                    },
                }
            },
            '.heading': {
                lineHeight: '1',
                display: 'block',
                [mobileOnly]: {
                    fontSize: 12,
                    marginTop: 5,
                },
                [tabletPortraitUp]: {
                    fontSize: 16,
                    marginTop: 10,
                },
            },
            '.product-ready': {
                'img': {
                    width: '100%',
                    display: 'block',
                    margin: '0 auto',
                    [mobileOnly]: {
                        maxWidth: 67,
                    },
                    [tabletPortraitUp]: {
                        maxWidth: 87,
                    }
                }
            },
        }
    }]),

    safety: css([{
        '.disclaimer': {
            textTransform: 'uppercase',
            marginBottom: 0,
            'span': {
                color: colors.RED,
            }
        }
    }]),

    productBar: css([{
        position: 'fixed',
        bottom: 0,
        backgroundColor: colors.PINK_LIGHT,
        width: '100%',
        visibility: 'hidden',
        opacity: 0,
        display: 'flex',
        left: 0,
        right: 0,
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        alignContent: 'flex-end',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        boxShadow: '0px -20px 50px rgba(56, 86, 167, 0.3)',
        transition: 'visibility 0.5s, opacity 0.5s linear',
        zIndex: 1,

        '&.scrolled': {
            visibility: 'visible',
            opacity: 1,
        },

        [mobileOnly]: {
            padding: '24px 20px',
            height: 100,
            alignItems: 'center',
            alignContent: 'center',
        },

        [tabletPortraitUp]: {
            padding: '33px 50px 33px 50px',
            height: 100,
        },

        [tabletLandscapeUp]: {
            display: 'none',
        },

        '.products-rating-container': {
            display: 'none'
        },

        '.box-ingredients': {
            display: 'none'
        },

        '.bar-product-image': {
            [smallMobile]: {
                width: 300,
                maxWidth: 108,
            },
            [mobileOnly]: {
                marginRight: 47,
                bottom: 49,
                width: 200,
                maxWidth: 108,
            },
            [tabletPortraitUp]: {
                marginRight: 36,
                bottom: 95,
                width: 280,
                height: 'auto',
            },
            'img': {
                display: 'block',
                width: '100%',
                height: 'auto',
            },
        },
        '.bar-control': {
            display: 'flex',
            flexGrow: 1,
            justifyContent: 'flex-end',
            alignItems: 'center',
            [mobileOnly]: {
                flexDirection: 'row',
                maxWidth: 200,
                width: '100%',
            },
            [tabletPortraitUp]: {
                flexDirection: 'row',
            },
        },
        '.qnty': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 7,
            [mobileOnly]: {
                marginBottom: 9,
            },
            [tabletPortraitUp]: {
                flexDirection: 'row',
                marginRight: 48,
            },

            '.decrease': {
                color: colors.RED,
                lineHeight: '50px',
                marginRight: 29,
                [mobileOnly]: {
                    fontSize: 30,
                    paddingBottom: 7,
                },
                [tabletPortraitUp]: {
                    fontSize: 46,
                    paddingBottom: 9,
                },
            },
            '.delete': {
                color: colors.RED,
                fontSize: 50,
                lineHeight: '50px',
                marginRight: 32,
                [mobileOnly]: {
                    fontSize: 30,
                },
                [tabletPortraitUp]: {
                    fontSize: 46,
                },
            },
            '.increase': {
                color: colors.RED,
                fontSize: 46,
                lineHeight: '50px',
                [mobileOnly]: {
                    fontSize: 30,
                    paddingBottom: 7,
                },
                [tabletPortraitUp]: {
                    fontSize: 46,
                    paddingBottom: 9,
                },
            },
        },
        'button.button.red.v2': {
            width: '100%',
            fontSize: 24,
            borderRadius: 42,
            [mobileOnly]: {
                maxWidth: 178,
                padding: '18px 10px',
                fontSize: 14,
            },
            [tabletPortraitUp]: {
                maxWidth: 300,
                padding: '31px 30px',
                fontSize: 24,
            },
        }

    }]),

    collaboration: css([{
        '.select__control': {
            border: 'white',
            color: '#15206B',
            fontSize: 30,
            lineHeight: '40px',
            textTransform: 'lowercase',
            marginBottom: 60,
            padding: '8px !important',

            '.select__single-value': {
                color: colors.NAVY,
            }
        },
        '.pdp-ingredients-wrapp': {
            width: '100%'
        },
        '.ingedients-list': {
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: 18,
            marginBottom: 60,
        },
        '.fda-slider': {
            maxWidth: 380,
            width: '100%',
            position: 'relative',
            marginBottom: 60,
            minHeight: 400,

            '.arrows': {
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'row',
                zIndex: 1,
                width: '100%',
                position: 'absolute',
                bottom: 300,

                '.left': {
                    marginLeft: '-45px',
                },
                '.right': {
                    marginRight: '-45px',
                },
            }
        },

        [mobileOnly]: {
            '.ingedients-list': {
                fontSize: 15,
                lineHeight: '145%',
            },
            '.select__control': {
                fontSize: 20,
                textTransform: 'lowercase',
                marginBottom: 60,
                padding: '6px !important',
            },
        },
        [max_900]: {
            '.product-image-wrapper': {
                height: '300px !important',
            }
        }
    }]),
    ratings: css({
        '.rating': {
            maxWidth: 120,
            marginLeft: 6,
        },
        '.read-reviews-button': {
            borderColor: `${colors.NAVY} !important`,
            backgroundColor: `${colors.NAVY} !important`,
            textDecoration: 'none',
            '&::after': {
                backgroundColor: 'transparent',
            },
            ':hover': {
                opacity: 0.8,
            }
        },

        '.container-product-ratings': {
            display: 'flex',
            justifyContent: 'space-between',

            [mobileOnly]: {
                flexDirection: 'column',
            }
        },

        '.left-section': {
            display: 'flex',
            flexDirection: 'column',

            '.rating-container': {
                display: 'flex',
                alignItems: 'center',
                marginBottom: 4,
            },

            '.rating-value': {
                fontWeight: 'bold',
                marginRight: 12,
            },

            '.total-value': {
                fontSize: 16,
                marginBottom: 24,
            }
        },

        '.right-section': {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: colors.WHITE,
            padding: 20,
            borderRadius: 36,
            marginLeft: 20,
            maxWidth: 400,
            
            [mobileOnly]: {
                padding: 20,
                maxWidth: 'unset',
                marginLeft: 0,
                marginBottom: 20,
            },

            '.review': {
                fontWeight: 'bold',
                marginTop: 20,

                [mobileOnly]: {
                    fontSize: 18,
                    lineHeight: 1.4
                }
            },

            '.owner': {
                marginTop: 20,
                fontSize: 18,

                [mobileOnly]: {
                    fontSize: 16,
                }
            }
        }
    }),
    bundleIncludes: css({
        display: 'flex',
        flexDirection: 'column',

        [mobileOnly]: {
            flexDirection: 'column-reverse',
        },

        '.brain-section': {
            display: 'flex',
            backgroundColor: colors.WHITE,
            padding: 48,
            borderRadius: 48,
            marginBottom: 48,
            position: 'relative',

            [mobileOnly]: {
                padding: 24,
                marginBottom: 0,
                flexDirection: 'column',
            },

            '.description-container': {
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                
                '.title': {
                    color: colors.BLUE,
                    marginBottom: 16,
                    fontSize: 18,

                    [mobileOnly]: {
                        fontSize: 16,
                        lineHeight: 1.4,
                    }
                },

                '.age': {
                    fontWeight: 'bold',
                    fontSize: 32,
                    marginBottom: 20,
                    color: colors.NAVY,

                    [mobileOnly]: {
                        fontSize: 24,
                    }
                },

                '.description': {
                    color: colors.BLUE,
                    fontSize: 14,
                    lineHeight: 1.45,

                    [mobileOnly]: {
                        marginBottom: 12,
                    }
                }
            },

            '.brain-container': {
                flex: 0.5,
                display: 'flex',

                [mobileOnly]: {
                    justifyContent: 'center',
                    img: {
                        width: 200,
                    }
                }
            }
        },

        '.includes-section': {
            '.bundle-items': {
                marginTop: 16,
                marginBottom: 24,
                '.bundle-item': {
                    fontWeight: 'bold'
                },
            },
            
            '.nutrient-items': {
                display: 'flex',
                flexWrap: 'wrap',

                [mobileOnly]: {
                    flexDirection: 'column',
                    marginBottom: 48,
                },

                '.nutrient-item': {
                    marginRight: 24,
                    fontSize: 14,
                    color: colors.BLUE,
                    img: {
                        width: 14,
                        marginRight: 8,
                    }
                }
            },
        }
    }),
    bundleNeurosurgeonFounded: css({
        '.cerebelly-labels': {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-around',

            '> div': {
                maxWidth: 128,
                width: '100%',
                textAlign: 'center',
                marginRight: 10,

                '> div': {
                    height: 65,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }
            },
            'img': {
                maxWidth: 100,
                width: '100%',
                display: 'block',
                margin: '0 auto',
            },
            '.number': {
                fontWeight: 800,
                lineHeight: '1',
                color: colors.RED,
                display: 'inline-flex',
                alignItems: 'flex-end',
                justifyContent: 'center',
                [mobileOnly]: {
                    width: 90,
                    height: 60,
                    fontSize: 80,
                },
                [tabletPortraitUp]: {
                    width: 100,
                    height: 70,
                    fontSize: 90,
                },
                '.grams': {
                    display: 'inline-block',
                    textTransform: 'uppercase',
                    [mobileOnly]: {
                        fontSize: 20,
                    },
                    [tabletPortraitUp]: {
                        fontSize: 30,
                    },
                }
            },
            '.heading': {
                lineHeight: 1,
                display: 'block',
                marginTop: 48,
                [mobileOnly]: {
                    fontSize: 12,
                },
                [tabletPortraitUp]: {
                    fontSize: 16,
                },
            },
            '.product-ready': {
                'img': {
                    width: '100%',
                    display: 'block',
                    margin: '0 auto',
                    [mobileOnly]: {
                        maxWidth: 67,
                    },
                    [tabletPortraitUp]: {
                        maxWidth: 87,
                    }
                }
            },
        }
    }),
    bundleUsVsThem: css({
        '.grid-container': {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            width: '100%',
            maxWidth: '600px',
            margin: '0px auto',
          
            '.grid-item': {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              paddingTop: 20,
              paddingBottom: 20,
              paddingLeft: 6,
              paddingRight: 6,

              '&:nth-child(3n + 2)': {
                backgroundColor: colors.WHITE,
              },
          
              '&:nth-child(2)': { 
                borderTopLeftRadius: 24,
                borderTopRightRadius: 24,
              },
          
              '&:nth-child(11)': {
                borderBottomLeftRadius: 24,
                borderBottomRightRadius: 24,
              }
            },

            '.title': {
                fontSize: 24,
            },

            '.category': {
                fontSize: 18,

                [mobileOnly]: {
                    fontSize: 14,
                    lineHeight: 1.4
                }
            },

            '.number': {
                fontSize: 48,
                fontWeight: 'bold',

                '&.red': {
                    color: colors.RED
                }
            },

            '.icon': {
                width: 36,
            },

            '.percentage': {
                fontSize: 24,
                fontWeight: 'bold',
                textAlign: 'center',
            }
          },

          '.notice': {
            fontSize: 14,
            color: colors.BLUE,
            marginTop: 24,

            [mobileOnly]: {
                display: 'none',
            }
          }
    }),
    bundleShopOthers: css({
         position: 'relative',
         paddingTop: 75,
         paddingLeft: 80,
         paddingRight: 80,
         borderRadius: 30,
         paddingBottom: '30%',
         overflow: 'hidden',

         [mobileOnly]: {
            paddingTop: 24,
            paddingLeft: 24,
            paddingRight: 24,
         },

        '.container': {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 20,
            padding: 0,

            '.link': {
                backgroundColor: colors.WHITE,
                padding: '8px 16px 8px 16px',
                borderRadius: 24,
                fontWeight: 'bold',

                [mobileOnly]: {
                    fontSize: 16,
                    padding: '4px 8px 4px 8px',
                }
            },

        },

        '.products': {
            width: '140%',
            position: 'absolute',
            left: '-19%',
            marginTop: 4,
        }
    }),

    buttonContainer: css({
        display: 'flex',
        justifyContent: 'center',
    }),


    showInsideButton: css({
        '&.primary': {
            backgroundColor: colors.ORANGE_TULIP_TREE,
            borderTopLeftRadius: 80,
            borderBottomLeftRadius: 80,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 40,
            height: 80,
            position: 'absolute',
            bottom: '45%',
            right: 0,
            zIndex: 1,

            img: {
                width: 14,
            },
            
            div: {
                display: 'none',
            },

            [tabletPortraitUp]: {
                width: 70,
                height: 140,

                img: {
                    width: 24,
                }
            },

            [tabletLandscapeUp]: {
                borderRadius: 80,
                width: 65,
                height: 65,
                right: 30,

                div: {
                    display: 'flex',
                    position: 'absolute',
                    top: 80,
                    fontWeight: 'bold',
                    fontSize: 12,
                    lineHeight: 1.4,
                    textAlign: 'center'
                },

                img: {
                    width: 18,
                }
            },
        },
        '&.secondary': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            padding: 12,
            paddingRight: 24,
            paddingLeft: 24,
            backgroundColor: colors.ORANGE_TULIP_TREE,
            marginRight: 100,
            marginLeft: 100,
            marginBottom: 48,
            alignSelf: 'center',
            justifySelf: 'center',
            justifyItems: 'center',
            alignContent: 'center',
            borderRadius: 40,
            maxWidth: 320,

            div: {
                color: colors.WHITE,
                fontWeight: 'bold',
                lineHeight: 1,
                marginRight: 20,
            },

            [tabletLandscapeUp]: {
                display: 'none',
            },

            [mobileOnly]: {
                fontSize: 16,
                marginRight: 24,
                marginLeft: 24,
                marginBottom: 24,

                img: {
                    width: 14,
                }
            }
        },

        '&.top': {
            left: 0,

            [tabletPortraitUp]: {
                left: 0,
            },

            [tabletLandscapeUp]: {
                left: 10,
            },

            [desktopUp]: {
                left: 10,
            },

            transform: 'rotate(180deg)',
        }
    })
};
